import 'intersection-observer'
import moment from 'moment'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { link, linkWrapper } from '../../../../cms/blocks/utils.gen'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { ButtonData } from '../../../../wordpress/types_and_parser/extra_types.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { getImageAttribute } from '../../../utils/extra_images.mod'


export type HeaderAttributes = {
  blockName: 'vidda/header'
  header_type: 'header one' | 'header two' | 'header three' | 'header four' | 'homepage' | 'error'
  title: string
  subtitle?: string
  intro?: string
  image_focus?: 'top' | 'middle' | 'bottom'
  image?: WordPress.MediaResponse
  image_mobile?: WordPress.MediaResponse
  primary_button?: ButtonData
  secondary_button?: ButtonData
  video_small?: string
  video_medium?: string
  video_large?: string
}

export interface HeaderInterface {
  blockName: 'vidda/header'
  attrs: HeaderAttributes
}

export type HeaderBlockProps<extra_images> = HeaderAttributes

export type HeaderBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

export const StringToHeaderType = (input: string) =>
    input === 'header one'
  ? 'header one'
  : input === 'header two'
  ? 'header two'
  : input === 'header three'
  ? 'header three'
  : input === 'header four'
  ? 'header four'
  : input === 'error'
  ? 'error'
  : 'homepage'
  

export function HeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        props.header_type == 'header one' ? primaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
        props.header_type == 'header two' ? secondaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
        props.header_type == 'header three' ? tertiaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
        props.header_type == 'header four' ? storyHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
        props.header_type == 'error' ? errorHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
        <>{homepageHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { })}
          <div className="block block--divider"></div>
        </>
      )
    })
  }
}

export function storyHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <header
          className={`hero hero--story${
            s.custom_page_data &&
              s.custom_page_data.v.kind == 'r' &&
              s.custom_page_data.v.v.post &&
              s.custom_page_data.v.v.post.is_front
              ? ' hero--home'
              : ''
            }
            ${props.title && props.intro ? ' hero--columns' : ''}`}
        >
          <div className="hero__inner container--l grid--gutter">
            <div className="hero__content grid--spacing">
              <div className="hero__text">

                {props.title && <h1 className="hero__title typo--3xl">{props.title}</h1>}

                {props.intro && (
                  <div className="hero__intro typo--m text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
                )}
              </div>
            </div>

            <div className={`hero__visual hero__visual--${props.image_focus}`}
              style={{backgroundImage: "url(" + getImageAttribute(props.image, 'header', 'source_url') + ")"}}>

              {props.image_mobile && props.image_mobile.media_details && (
                <img
                  src={getImageAttribute(props.image_mobile, 'header', 'source_url')}
                  width={getImageAttribute(props.image_mobile, 'header', 'width')}
                  height={getImageAttribute(props.image_mobile, 'header', 'height')}
                  className="hero__image hero__image--mobile"
                  alt={props.image_mobile.alt_text ? props.image_mobile.alt_text : ''}
                />
              )}
            </div>

          </div>
        </header>
      )
    })
  }
}

export function errorHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <header className={`hero hero--secondary hero--wave`} >
          <div className="hero__inner container--xl grid--block">
            <div className="hero__content">
              <div className="hero__text">
                {props.title && <h1 className="hero__title typo--4xl">{props.title}</h1>}
              </div>
            </div>
          </div>
        </header>
      )
    })
  }
}

export function primaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <header
          className={`hero hero--primary${
            s.custom_page_data &&
              s.custom_page_data.v.kind == 'r' &&
              s.custom_page_data.v.v.post &&
              s.custom_page_data.v.v.post.is_front
              ? ' hero--home'
              : ''
            }`}
        >
          <div className="hero__inner container">
            <div className="hero__content container--xl grid--gutter">
              <div className="hero__text">

                {props.title && <h1 className="hero__title">{props.title}</h1>}

                {props.subtitle && (
                  <div className="hero__intro typo--xl text--styled" dangerouslySetInnerHTML={{ __html: props.subtitle }} />
                )}
              </div>
            </div>
            <div className={`hero__visual hero__visual--${props.image_focus} fit-object`}>
            {props.image && props.image.media_details && (
              <img
                src={getImageAttribute(props.image, 'header', 'source_url')}
                width={getImageAttribute(props.image, 'header', 'width')}
                height={getImageAttribute(props.image, 'header', 'height')}
                className="hero__image hero__image--desktop"
                alt={props.image.alt_text ? props.image.alt_text : ''}
              />
            )}
            {props.image_mobile && props.image_mobile.media_details && (
              <img
                src={getImageAttribute(props.image_mobile, 'header', 'source_url')}
                width={getImageAttribute(props.image_mobile, 'header', 'width')}
                height={getImageAttribute(props.image_mobile, 'header', 'height')}
                className="hero__image hero__image--mobile"
                alt={props.image_mobile.alt_text ? props.image_mobile.alt_text : ''}
              />
            )}
            </div>
          </div>
        </header>

      )
    })
  }
}

export function secondaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <>
        <header
          className={`hero hero--secondary${
            s.custom_page_data &&
              s.custom_page_data.v.kind == 'r' &&
              s.custom_page_data.v.v.post &&
              s.custom_page_data.v.v.post.is_front
              ? ' hero--home'
              : ''
            }
            ${props.image && props.image.media_details ? ' hero--image' : ' hero--wave'}`}
        >
          <div className="hero__inner container--xl grid--block">
            <div className="hero__content">
              <div className="hero__text">

                {props.title && <h1 className="hero__title typo--4xl">{props.title}</h1>}

                {s.custom_page_data.v.kind == 'r' && s.custom_page_data.v.v.post.type == 'news' &&
                  <time className="hero__label typo--3xs">{moment(s.custom_page_data.v.v.post.date).locale(window.wp.language).format(window.wp.language == 'de' ? 'D. MMMM YYYY' : 'D MMMM YYYY')}</time>
                }

                {props.intro && (
                  <div className="hero__intro typo--m text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
                )}

                {(props.primary_button || props.secondary_button) && (
                    <ul className="hero__buttons">
                      {props.primary_button && (
                        <li className="hero__button">
                          {link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                            { classname: 'button button--primary' },
                            props.primary_button.text
                          )}
                        </li>
                      )}
                      {props.secondary_button && (
                        <li className="hero__button">
                          {link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                            { classname: 'button button--secondary' },
                            props.secondary_button.text
                          )}
                        </li>
                      )}
                    </ul>
                  )}

              </div>
            </div>
            {props.image && props.image.media_details && (
              <div className={`hero__visual hero__visual--${props.image_focus} fit-object`}>
                <img
                  src={getImageAttribute(props.image, 'header', 'source_url')}
                  width={getImageAttribute(props.image, 'header', 'width')}
                  height={getImageAttribute(props.image, 'header', 'height')}
                  className="hero__image"
                  alt={props.image.alt_text ? props.image.alt_text : ''}
                />
              </div>
            )}
          </div>
        </header>
      </>
      )
    })
  }
}

export function tertiaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <header
          className={`hero hero--tertiary${
            s.custom_page_data &&
              s.custom_page_data.v.kind == 'r' &&
              s.custom_page_data.v.v.post &&
              s.custom_page_data.v.v.post.is_front
              ? ' hero--home'
              : ''
            }`}
        >
          <div className="hero__inner container--l grid--gutter">
            <div className="hero__content grid--spacing">
             <div className="hero__text">

                {props.title && <h1 className="hero__title typo--4xl">{props.title}</h1>}

                {props.intro && (
                  <div className="hero__intro typo--m text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
                )}

                {(props.primary_button || props.secondary_button) && (
                    <ul className="hero__buttons">
                      {props.primary_button && (
                        <li className="hero__button">
                          {link(linkWrapper({title:props.primary_button.text, url:props.primary_button.url}),
                            { classname: 'button button--primary' },
                            props.primary_button.text
                          )}
                        </li>
                      )}
                      {props.secondary_button && (
                        <li className="hero__button">
                          {link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                            { classname: 'button button--secondary' },
                            props.secondary_button.text
                          )}
                        </li>
                      )}
                    </ul>
                  )}

              </div>
            </div>
            <div className={`hero__visual hero__visual--${props.image_focus} fit-object`}>
            {props.image && props.image.media_details && (
              <img
                src={getImageAttribute(props.image, 'header', 'source_url')}
                width={getImageAttribute(props.image, 'header', 'width')}
                height={getImageAttribute(props.image, 'header', 'height')}
                className="hero__image hero__image--desktop"
                alt={props.image.alt_text ? props.image.alt_text : ''}
              />
            )}
            {props.image_mobile && props.image_mobile.media_details && (
              <img
                src={getImageAttribute(props.image_mobile, 'header', 'source_url')}
                width={getImageAttribute(props.image_mobile, 'header', 'width')}
                height={getImageAttribute(props.image_mobile, 'header', 'height')}
                className="hero__image hero__image--mobile"
                alt={props.image_mobile.alt_text ? props.image_mobile.alt_text : ''}
              />
            )}
            </div>
          </div>
        </header>

      )
    })
  }
}



export function homepageHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }


): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: (_) => (
        <InView
          as="header"
          onChange={e => headerInView()}
          className="hero hero--homepage"
          id="hero-home"
          threshold={0.1}
          triggerOnce={false}>
          <div className="hero__inner">
            <div className="hero__content grid--block container container--2xl">
              {props.title && <h1 className="hero__title typo--4xl">{props.title}</h1>}
              {props.intro && (
                <div className="hero__intro text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
              )}

              {(props.primary_button || props.secondary_button) && (
                <footer className="hero__buttons">
                  {props.primary_button &&
                    link(
                      linkWrapper({ title: props.primary_button.text, url: props.primary_button.url }),
                      { classname: 'link link--primary' },
                      props.primary_button.text
                    )}
                </footer>
              )}
            </div>

            {props.video_small && props.video_medium && props.video_large ? (
              <div className={`hero__visual hero__visual--${props.image_focus} hero__visual--video`}>
                <video
                id="homepage-header-video"
                className="page__header-video fit-object"
                width="960"
                height="540"
                autoPlay
                loop
                muted
                playsInline
                src={window.innerWidth < 767 ? props.video_small
                  : window.innerWidth >= 768 && window.innerWidth < 1023 ? props.video_medium
                    : props.video_large}></video>
              </div>
            ) : (
              props.image &&
              props.image.media_details && (
                <div className={`hero__visual hero__visual--${props.image_focus}`}>
                  <img src={getImageAttribute(props.image, 'header', 'source_url')} alt={props.image.alt_text} />
                </div>
              )
            )}
          </div>
          {headerInView()}
        </InView>
      ),
    })
  }
}

export function headerInView() {
  let currentPosition: number = window.scrollY;
  const heroHome: HTMLElement = document.documentElement.querySelector('.hero--homepage')
  const header: HTMLElement = document.documentElement.querySelector('.header')
  if (heroHome == null) return
  const heroHeight: number = heroHome.getBoundingClientRect().height
  const headerHeight: number = header.getBoundingClientRect().height

  if (currentPosition < ((heroHeight / 2) + headerHeight)) {
    heroHome.classList.add('hero--fade-in')

    if (heroHome.classList.contains('hero--fade-away')) {
      heroHome.classList.remove('hero--fade-away')
    }
  } else {
    if (heroHome.classList.contains('hero--fade-in')) {
      heroHome.classList.remove('hero--fade-in')
    }
    heroHome.classList.add('hero--fade-away')
  }
}

document.addEventListener('scroll', (e) => headerInView())
window.addEventListener('resize', (e) => headerInView())
